
const messages = {
    en: {
       role: {
            permissions: {
                CONVENIO_MENU: "Access to Convenio",
                CONVENIO_SHOW: "View Convenio",
                CONVENIO_AGENCIA_SHOW: "View Convenio from my agency",
                CONVENIO_CREATE: "Create Convenio",
                CONVENIO_UPDATE: "Modify Convenio",
                CONVENIO_DELETE: "Delete Convenio",
                CONVENIO_FUERA_DE_PAUTA: "Create Convenio fuera de pauta",
                CONVENIO_QUITA_ESPECIAL: "Apply special quita in Convenio",
                CONVENIO_VIGENCIA: "Change Convenio vigencia",
                CONVENIO_EXPORT: "Export Convenios",
                CONVENIO_PAGOS: "View Convenio payments",
                CONVENIO_SELECT_DEUDAS: "Select debts in Convenio",
                CONVENIO_SELECT_COBRANZAS: "Select collections in Convenio",
                CONVENIO_VER_DEUDAS: "View debts in Convenio",
                CONVENIO_VER_COBRANZAS: "View collections in Convenio",
                CONVENIO_MONTO_COBRADO: "View Monto Cobrado",
            }
       }
    },
    es: {
        role: {
            permissions: {
                CONVENIO_MENU: "Acceder Convenio",
                CONVENIO_SHOW: "Ver Convenio",
                CONVENIO_AGENCIA_SHOW: "Ver Convenios de mi agencia",
                CONVENIO_CREATE: "Crear Convenio",
                CONVENIO_UPDATE: "Modificar Convenio",
                CONVENIO_DELETE: "Eliminar Convenio",
                CONVENIO_FUERA_DE_PAUTA: "Crear Convenio fuera de pauta",
                CONVENIO_QUITA_ESPECIAL: "Aplicar quita especial en Convenio",
                CONVENIO_VIGENCIA: "Modificar vigencia de Convenio",
                CONVENIO_EXPORT: "Exportar Convenios",
                CONVENIO_PAGOS: "Ver pagos de Convenio",
                CONVENIO_SELECT_DEUDAS: "Seleccionar deudas en Convenio",
                CONVENIO_SELECT_COBRANZAS: "Seleccionar cobranzas en Convenio",
                CONVENIO_VER_DEUDAS: "Ver deudas en Convenio",
                CONVENIO_VER_COBRANZAS: "Ver cobranzas en Convenio",
                CONVENIO_MONTO_COBRADO: "Ver monto cobrado Convenio",
            }
       }
    },
    pt: {
       role: {
            permissions: {
                CONVENIO_MENU: "Acessar Convenio",
                CONVENIO_SHOW: "Ver Convenio",
                CONVENIO_AGENCIA_SHOW: "Ver Convenios da minha agencia",
                CONVENIO_CREATE: "Criar Convenio",
                CONVENIO_UPDATE: "Modificar Convenio",
                CONVENIO_DELETE: "Eliminar Convenio",
                CONVENIO_FUERA_DE_PAUTA: "Criar Convenio fora da pauta",
                CONVENIO_QUITA_ESPECIAL: "Aplicar quita especial no Convenio",
                CONVENIO_VIGENCIA: "Modificar vigencia do Convenio",
                CONVENIO_EXPORT: "Exportar Convenios",
                CONVENIO_PAGOS: "Ver pagamentos de Convenio",
                CONVENIO_SELECT_DEUDAS: "Selecionar dividas no Convenio",
                CONVENIO_SELECT_COBRANZAS: "Selecionar cobranzas no Convenio",
                CONVENIO_VER_DEUDAS: "Ver dividas no Convenio",
                CONVENIO_VER_COBRANZAS: "Ver cobranzas no Convenio",
                CONVENIO_MONTO_COBRADO: "Ver monto cobrado Convenio",
            }
       }
    }
}

export default messages
